import { getGridLocalization } from "../utils/getGridLocalization.js";
import { GRID_DEFAULT_LOCALE_TEXT } from "../constants/localeTextConstants.js";
export const enUS = getGridLocalization(GRID_DEFAULT_LOCALE_TEXT);